const getRefreshAccessToken = (): Promise<any> =>
  gapi.client.request({
    path: '/oauth2/v4/token',
    method: 'POST',
    body: {
      client_id: process.env.CLIENT_ID,
      client_secret: process.env.CLIENT_SECRET,
      refresh_token: process.env.REFRESH_TOKEN,
      grant_type: 'refresh_token',
    },
  });

const load = (name: string, version: string) => gapi.client.load(name, version);

export { getRefreshAccessToken, load };
